var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',{staticClass:"pa-0"},[(_vm.whichProgramOpened('Ofispro'))?_c('ofispro-home-view'):_vm._e(),(_vm.whichProgramOpened('IcraproWeb'))?_c('icrapro-home-view'):_vm._e(),(_vm.whichProgramOpened('e-İcrapro'))?_c('e-icrapro-home-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }